import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import moment from "moment";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import Logs from "../../Logs/Logs";
import { HandlePurchaseRequestStatus } from "../../../utility/CommonFunctions";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import MainHeading from "../../../components/comman/MainHeading";

export default function StockOutDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [refreshLogs, setRefreshLogs] = useState(false);
  const [modalType, setModalType] = useState("");
  const [pageStates, setPageStates] = useState({
    stockOutDetail: [],
  });
  const [modal, setModal] = useState({
    approveRejectModal: false,
  });

  useEffect(() => {
    GetStockOutDetail();
  }, []);

  const GetStockOutDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_stock_out_detail + `?stockOutId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          stockOutDetail: response?.data,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  const toggle = (type) => {
    setModal((prevModal) => ({
      ...prevModal,
      approveRejectModal:
        type === "approveReject"
          ? !prevModal.approveRejectModal
          : prevModal.approveRejectModal,
    }));
  };

  const handleReqStatus = (status, reason = "") => {
    setIsLoading(true);

    let postData = {
      status: status,
      ...(status === "Rejected" && { rejectReason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };

    callApi(apiUrl.update_stock_out_status + `?stockOutId=${id}`, option).then(
      (res) => {
        setIsLoading(false);
        if (res?.status === true) {
          toast.success(res?.message);
          GetStockOutDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
        toggle("approveReject");
      }
    );
  };

  return (
    <>
      {isLoading && <BgBlurLoader />}
      <div className="content container-fluid">
        <MainHeading title="Stock Out Detail" showBackButton={true} />
        <div className="card manage-user-list">
          <div className="card-body">
            <ul
              className={
                isLoading
                  ? "row list-unstyled mt-4 loading-skeleton"
                  : "row list-unstyled mt-4"
              }
            >
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Stock Out Number :-
                  </span>
                  {pageStates?.stockOutDetail?.stockOutNumber || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">Site :-</span>
                  {pageStates?.stockOutDetail?.site?.name || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">Date :-</span>
                  {moment(pageStates?.stockOutDetail?.date).format(
                    "DD-MM-YYYY"
                  ) || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Created By :-
                  </span>
                  {pageStates?.stockOutDetail?.user?.name || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4 text-capitalize">
                <p>
                  <span className="text-muted fs-5 d-block">Type :-</span>
                  {pageStates?.stockOutDetail?.type || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">Status :-</span>
                  {HandlePurchaseRequestStatus(
                    pageStates?.stockOutDetail?.status
                  )}
                </p>
              </li>
              {pageStates?.stockOutDetail?.rejectReason && (
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Reject Rearon :-
                    </span>
                    {pageStates?.stockOutDetail?.rejectReason}
                  </p>
                </li>
              )}
            </ul>
            <div className="col-12 ">
              <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                <h4 className="fs-3 rajdhani-semibold my-4 ">Items</h4>
              </div>
              <table className="table mt-3">
                <thead>
                  <tr>
                    <th className="text-start">Item</th>
                    <th className="text-start">Expense Head</th>
                    <th className="text-start">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {pageStates?.stockOutDetail?.StockOutItems?.length > 0 ? (
                    pageStates?.stockOutDetail?.StockOutItems?.map?.(
                      (item, index) => (
                        <tr key={index}>
                          <td className="text-start">{item?.item?.name}</td>
                          <td className="text-start">{item?.expensehead?.name}</td>
                          <td className="text-start">{item?.quantity}</td>
                        </tr>
                      )
                    )
                  ) : (
                    <tr>
                      <td className="text-center border-0" colSpan="12">
                        <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error">
                          <NoRecordIcon />
                          {"No record found"}
                        </div>
                      </td>
                    </tr>
                  )}

                  <tr className="d-none">
                    <td colspan="11" className="text-center fw-bold">
                      No Data Found
                    </td>
                  </tr>
                </tbody>
                {pageStates?.stockOutDetail?.StockOutItems?.length > 0 && (
                  <tfoot>
                    <tr className="fw-bold">
                      <td className="text-start"></td>
                      <td className="text-start">Total</td>
                      <td className="text-start">
                        {pageStates?.stockOutDetail?.StockOutItems?.reduce(
                          (total, curr) =>
                            total + Number(curr?.quantity || 0),
                          0
                        )}
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
            {!isLoading && pageStates?.stockOutDetail?.canChangeStatus && (
              <div className="d-flex align-items-center justify-content-end gap-3 mb-3">
                <button
                  className="btn btn-danger px-5"
                  type="button"
                  onClick={() => {
                    setModalType("reject");
                    toggle("approveReject");
                  }}
                >
                  Reject
                </button>
                <button
                  className="btn btn-success px-5"
                  type="button"
                  onClick={() => {
                    setModalType("approve");
                    toggle("approveReject");
                  }}
                >
                  Approve
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Logs
        type={"stockOut"}
        id={id}
        refreshLogs={refreshLogs}
        setRefreshLogs={setRefreshLogs}
      />

      <ApproveRejectModal
        modal={modal.approveRejectModal}
        toggle={() => toggle("approveReject")}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject" ? "Rejected" : "Approved",
            reason
          )
        }
        isLoading={isLoading}
        actionType={modalType}
      />
    </>
  );
}
